
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Header: () => import("@/components/Jobs/Common/Header.vue"),
    OfferInfo: () => import("@/components/Jobs/Common/OfferInfo.vue"),
    Compatibility: () => import("@/components/Compatibility.vue"),
    Postulate: () => import("@/components/postulation/Postulate.vue"),
    Footer: () => import("@/components/Jobs/Homepage/Footer.vue"),
    PostulationQuick: () =>
      import("@/components/postulation/PostulationQuick.vue")
  }
})
export default class SearchResults extends Vue {
  // updateSelected(tab: any) {
  //   this.selectedTab = tab;
  //   if (this.isMobile) {
  //     this.$router.push("/oferta-detalle/" + tab);
  //     window.scrollTo(0, 0);
  //   }
  // }
  offer = {};
  link_social = "";
  shareModal = false;

  async mounted() {
    const _this: any = this;
    _this.link_social = window.location.origin;

    let response = await (this as any).$root._get(
      "offer/one/" + (this as any).$route.params.id,
      {}
    );
    this.offer = response.data[0];
  }

  timestamp(tm: any) {
    let diff = Date.now() - tm;
    if (!diff) {
      return "";
    }

    let diffDays = Math.floor(diff / 86400000);
    let diffHrs = Math.floor((diff % 86400000) / 3600000);
    let diffMins = Math.round(((diff % 86400000) % 3600000) / 60000);

    if (diffDays > 0) {
      return diffDays === 1 ? diffDays + "day" : diffDays + "days";
    } else if (diffHrs > 0) {
      return diffHrs === 1 ? diffHrs + "hr" : diffHrs + "hrs";
    } else if (diffMins > 0) {
      return diffMins === 1 ? diffMins + "min" : diffMins + "mins";
    }
  }

  openModal() {
    if ((this as any).$store.state.token) {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "Postulate";
        }
      );
      postulateComponent.offerId = (this as any).offer.id;
      postulateComponent.showModal();
    } else {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "PostulationQuick";
        }
      );
      postulateComponent.offerId = (this as any).offer.id;
      postulateComponent.showModal();
    }
  }

  async toggleOffer() {
    const _this: any = this;
    _this.offer.favorite = !_this.offer.favorite;
    await _this.$root._post(`useroffer`, {
      offerId: _this.offer.id,
      postulate: _this.offer.postulate ? 1 : 0,
      favorite: _this.offer.favorite ? 1 : 0
    });
    let response = await (this as any).$root._get(
      "offer/one/" + (this as any).$route.params.id,
      {}
    );
    this.offer = response.data[0];
    _this.$root.reloadUser();
    // (location as any).reload();
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }
}
